import React, { useState } from 'react';
import './Target.css';

const Target = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [stateFilter, setStateFilter] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [showDropdown, setShowDropdown] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    stateHead: '',
    target: '',
    month: '',
    startDate: '',
    endDate: ''
  });

  const targetData = [
    {
      id: 1,
      agentName: 'Suraj Kumar',
      agentCode: '210923',
      role: 'District Coordinator',
      phone: '+91 8302923880',
      email: 'Suraj@gmail.com',
      target: '₹ 2,23,000',
      completed: '₹ 2,23,000'
    },
    {
      id: 2,
      agentName: 'Suraj Kumar',
      agentCode: '210923',
      role: 'Commissionery Manager',
      phone: '+91 8302923880',
      email: 'Suraj@gmail.com',
      target: '₹ 5,00,000',
      completed: '₹ 5,00,000'
    },
    {
      id: 3,
      agentName: 'Suraj Kumar',
      agentCode: '210923',
      role: 'State Head',
      phone: '+91 8302923880',
      email: 'Suraj@gmail.com',
      target: '₹ 12,00,000',
      completed: '₹ 12,00,000'
    }
  ];

  return (
    <div className="target-page">
      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-info">
            <span className="stat-label">Target Assigned</span>
            <span className="stat-value">1381</span>
          </div>
          <div className="stat-icon target-icon">🎯</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-info">
            <span className="stat-label">Completed Target</span>
            <span className="stat-value">1381</span>
          </div>
          <div className="stat-icon completed-icon">🎯</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-info">
            <span className="stat-label">Pending Target</span>
            <span className="stat-value">1381</span>
          </div>
          <div className="stat-icon pending-icon">🎯</div>
        </div>
      </div>

      <div className="target-section">
        <div className="target-header">
          <h3>👥 Target Management</h3>
          <div className="target-actions">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon">🔍</span>
            </div>
            <select 
              className="filter-select"
              value={stateFilter}
              onChange={(e) => setStateFilter(e.target.value)}
            >
              <option value="">State</option>
              <option value="delhi">Delhi</option>
              <option value="mumbai">Mumbai</option>
            </select>
            <select 
              className="filter-select"
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
            >
              <option value="">Role</option>
              <option value="district">District Coordinator</option>
              <option value="manager">Commissionery Manager</option>
              <option value="head">State Head</option>
            </select>
            <button className="filter-btn">⚙️</button>
            <button className="add-btn" onClick={() => setShowAddModal(true)}>Add Target</button>
          </div>
        </div>

        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>Agent Name</th>
                <th>Agent Code</th>
                <th>Role</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Target</th>
                <th>Completed</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {targetData.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.agentName}</td>
                  <td>{item.agentCode}</td>
                  <td>{item.role}</td>
                  <td>{item.phone}</td>
                  <td>{item.email}</td>
                  <td>{item.target}</td>
                  <td>{item.completed}</td>
                  {/* <td>
                    <div className="action-dropdown">
                      <button 
                        className="action-btn"
                        onClick={() => setShowDropdown(showDropdown === index ? null : index)}
                      >
                        ⋯
                      </button>
                      {showDropdown === index && (
                        <div className="dropdown-menu">
                          <button onClick={() => setShowDropdown(null)}>
                            👁️ View
                          </button>
                          <button onClick={() => setShowDropdown(null)}>
                            ✏️ Edit
                          </button>
                          <button 
                            onClick={() => {
                              if(window.confirm('Are you sure you want to delete this target?')) {
                                console.log('Delete:', item);
                              }
                              setShowDropdown(null);
                            }}
                            className="delete-btn"
                          >
                            🗑️ Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </td> */}

                   <td>
                    <div className="action-icons">
                      <button
                        className="icon-btn view"
                         onClick={() => setShowDropdown(null)}
                        title="View"
                      >
                        👁️
                      </button>

                      <button
                        className="icon-btn edit"
                        onClick={() => setShowDropdown(null)}
                        title="Edit"
                      >
                        ✏️
                      </button>

                      <button
                        className="icon-btn delete"
                        onClick={() => {
                              if(window.confirm('Are you sure you want to delete this target?')) {
                                console.log('Delete:', item);
                              }
                              setShowDropdown(null);
                            }}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Add Target</h2>
            
            <div className="form-row">
              {/* <div className="form-group">
                <label>Target Type</label>
                <select className="form-select" disabled>
                  <option>State</option>
                </select>
              </div>
               */}
              <div className="form-group">
                <label>State Head</label>
                <select 
                  className="form-select"
                  value={formData.stateHead}
                  onChange={(e) => setFormData({...formData, stateHead: e.target.value})}
                >
                  <option value="">Select State Head</option>
                  <option value="delhi">Hari</option>
                  <option value="mumbai">Naveen</option>
                  <option value="kolkata">Sankar</option>
                  <option value="chennai">Rinku</option>
                </select>
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Enter Target</label>
                <input 
                  type="text"
                  className="form-input"
                  placeholder="Enter Target"
                  value={formData.target}
                  onChange={(e) => setFormData({...formData, target: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Month</label>
                <select 
                  className="form-select"
                  value={formData.month}
                  onChange={(e) => setFormData({...formData, month: e.target.value})}
                >
                  <option value="">Select Month</option>
                  <option value="january">January</option>
                  <option value="february">February</option>
                  <option value="march">March</option>
                  <option value="april">April</option>
                  <option value="may">May</option>
                  <option value="june">June</option>
                  <option value="july">July</option>
                  <option value="august">August</option>
                  <option value="september">September</option>
                  <option value="october">October</option>
                  <option value="november">November</option>
                  <option value="december">December</option>
                </select>
              </div>

            </div>


                <div className="form-row">

                  <div className="form-group">
                <label>Start Date</label>
                <input 
                  type="date"
                  className="form-input"
                  value={formData.startDate}
                  onChange={(e) => setFormData({...formData, startDate: e.target.value})}
                />
              </div>
              
              <div className="form-group">
                <label>End Date</label>
                <input 
                  type="date"
                  className="form-input"
                  value={formData.endDate}
                  onChange={(e) => setFormData({...formData, endDate: e.target.value})}
                />
              </div>
              
              

              </div>

            
            <div className="modal-actions">
              <button 
                className="cancel-btn"
                onClick={() => {
                  setShowAddModal(false);
                  setFormData({
                    stateHead: '',
                    target: '',
                    month: '',
                    startDate: '',
                    endDate: ''
                  });
                }}
              >
                Cancel
              </button>
              <button 
                className="done-btn"
                onClick={() => {
                  console.log('Form Data:', formData);
                  setShowAddModal(false);
                  setFormData({
                    stateHead: '',
                    target: '',
                    month: '',
                    startDate: '',
                    endDate: ''
                  });
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Target;